<template>
  <ul class="tree">
    <li v-for="item in items" :key="item.id">
      <div class="tree-item" :class="{ active: item.id === active.id }">
        <div class="arrow">
          <b-icon icon="chevron-right" />
        </div>
        <div class="item" @click="select(item)">
          <img class="mr-2" src="/images/folder.png" />
          <div
            class="item-title"
            :class="{ 'font-weight-bold': item.id === null }"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <tree-node
        v-if="item.children"
        :items="item.children"
        :active="active"
        @select="select"
      />
    </li>
  </ul>
</template>
<script>
export default {
  name: 'TreeNode',
  props: {
    items: Array,
    active: Object,
  },
  methods: {
    select(item) {
      this.$emit('select', item)
    },
  },
}
</script>
